import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import DaywiseSalesTrendReportView from './DaywiseSalesTrendReportView'

const DaywiseSalesTrendReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Daywise Sales Trend Report" mainTitle="Daywise Sales Trend Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <DaywiseSalesTrendReportView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default DaywiseSalesTrendReport